import { currencySymbolSet } from '../services/subscription/types';

export const isFxSymbol = (symbol: string): boolean => currencySymbolSet.has(symbol);
